import Resizer from "react-image-file-resizer";
import { UrlIsValid } from "../../../services/validations";

// Image Validations
export const isImageValid = file => {
  if (file.type.indexOf("image") == -1) {
    document.getElementById("__companyLogoError").innerHTML =
      "File not supported. (Supported: .jpeg, .png, .svg)";
    return false;
  }
  if (file.size > 5242880) {
    document.getElementById("__companyLogoError").innerHTML =
      "Image too big (max 5MB)";
    return false;
  }
  document.getElementById("__companyLogoError").innerHTML = "";
  return true;
};

// Image resizer
export const resizeFile = file =>
  new Promise(resolve => {
    Resizer.imageFileResizer(
      file,
      1072,
      320,
      "JPEG",
      100,
      0,
      uri => {
        resolve(uri);
      },
      "blob"
    );
  });

// Checking if the any field is empty
const isEmpty = obj => {
  console.log(obj);
  // return false;
  if (Object.keys(obj).length === 0) {
    return true;
  }

  let emptyObj = {};
  for (const key in obj) {
    if (obj[key] == "" || obj[key] === null || obj[key] === undefined) {
      emptyObj[key] = obj[key];
    }
  }
  console.log({ emptyObj });
  return Object.values(emptyObj).length > 0 ? emptyObj : null;
};

// Checking if form is valid
export const resourceIsValid = obj => {
  let error = {};
  let emptyObj = isEmpty(obj);
  console.log({
    title: obj.pageTitle.length,
    desc: obj.pageMetaDescription.length
  });
  if (emptyObj) {
    error.emptyFields = emptyObj;
  }
  if (obj.pageLink && !UrlIsValid(obj.pageLink)) {
    error.pageLink = "This must be a valid URL.";
  }
  if (
    obj.pageMetaDescription &&
    (obj.pageMetaDescription.length > 130 ||
      obj.pageMetaDescription.length < 70)
  ) {
    error.pageMetaDescription =
      "This must be in the range 70 to 130 characters.";
  }
  if (
    obj.pageTitle &&
    (obj.pageTitle.length > 60 || obj.pageTitle.length < 30)
  ) {
    error.pageTitle = "This must be in the range 30 to 60 characters.";
  }
  return Object.values(error).length > 0 ? error : null;
};
